import axios from 'axios';
import MockAdapter from 'axios-mock-adapter';

type User = {
    id: number;
    email?: string;
    name: string;
    role: string;
    token: string;
};

const TOKEN =
    'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJjb2RlcnRoZW1lcyIsImlhdCI6MTU4NzM1NjY0OSwiZXhwIjoxOTAyODg5NDQ5LCJhdWQiOiJjb2RlcnRoZW1lcy5jb20iLCJzdWIiOiJzdXBwb3J0QGNvZGVydGhlbWVzLmNvbSIsImxhc3ROYW1lIjoiVGVzdCIsIkVtYWlsIjoic3VwcG9ydEBjb2RlcnRoZW1lcy5jb20iLCJSb2xlIjoiQWRtaW4iLCJmaXJzdE5hbWUiOiJIeXBlciJ9.P27f7JNBF-vOaJFpkn-upfEh3zSprYfyhTOYhijykdI';

var mock = new MockAdapter(axios, { onNoMatch: 'passthrough' });

export function configureFakeBackend() {
    // mock.onGet('/users/').reply(function (config) {
    //     return new Promise((resolve, reject) => {
    //         setTimeout(() => {
    //             resolve([200, userTableData]);
    //         }, 500);
    //     });
    // });

    mock.onGet('/user-type/').reply(function (config) {
        const usertypeList = [
            { id: 1, label: 'UserType 1' },
            { id: 2, label: 'UserType 2' },
            { id: 3, label: 'UserType 3' },
        ];
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve([200, usertypeList]);
            }, 500);
        });
    });

    mock.onPost('/sensors/').reply(function (config) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                let params = JSON.parse(config.data);
                let newSensor = {
                    customerId: params.customerId,
                    areaId: params.areaId,
                    subAreaId: params.subAreaId,
                    machineId: params.machineId,
                    name: params.name,
                    bearingLocationId: params.bearingLocationId,
                };
                resolve([200, newSensor]);
            }, 1000);
        });
    });

    mock.onPost('/users/').reply(function (config) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                let params = JSON.parse(config.data);
                let newUser = {
                    name: params.name,
                    contactNumber: params.contactNumber,
                    email: params.email,
                    userTypeId: params.userTypeId,
                    customerId: params.customerId,
                    areaId: params.areaId,
                };
                resolve([200, newUser]);
            }, 1000);
        });
    });

    mock.onPost('/register/').reply(function (config) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                // get parameters from post request
                let params = JSON.parse(config.data);

                // add new users
                let [firstName] = params.fullname.split(' ');
                let newUser: User = {
                    id: 1,
                    name: firstName,
                    email: firstName,
                    role: 'Admin',
                    token: TOKEN,
                };

                resolve([200, newUser]);
            }, 1000);
        });
    });

    mock.onPost('/forget-password/').reply(function (config) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                // get parameters from post request

                // find if any user matches login credentials
                let filteredUsers = [];

                if (filteredUsers.length) {
                    // if login details are valid return user details and fake jwt token
                    let responseJson = {
                        message: "We've sent you a link to reset password to your registered email.",
                    };
                    resolve([200, responseJson]);
                } else {
                    // else return error
                    resolve([
                        401,
                        {
                            message: 'Sorry, we could not find any registered user with entered username',
                        },
                    ]);
                }
            }, 1000);
        });
    });
}
